import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GroupMaintenanceRoutingModule } from './group-maintenance-routing.module';
import { GroupMaintenanceComponent } from './group-maintenance.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { GroupMaintenanceDetailComponent } from './group-maintenance-detail/group-maintenance-detail.component';
import { GrpMntDetailModalComponent } from './grp-mnt-detail-modal/grp-mnt-detail-modal.component';
import { GrpMntWebUserModalComponent } from './grp-mnt-web-user-modal/grp-mnt-web-user-modal.component';
import { GrpMntRecipientModalComponent } from './grp-mnt-recipient-modal/grp-mnt-recipient-modal.component';
import { GroupMaintenanceFilterComponent } from './group-maintenance-filter/group-maintenance-filter.component';
import { WebUserDropdownModule } from 'src/app/core/custom-modules/dropdowns/web-user-dropdown/web-user-dropdown.module';
import { WebUserMultiselectDropdownModule } from 'src/app/core/custom-modules/dropdowns/web-user-multiselect-dropdown/web-user-multiselect-dropdown.module';
import { RecipientDropdownModule } from 'src/app/core/custom-modules/dropdowns/recipient-dropdown/recipient-dropdown.module';
import { RecipientMultiselectDropdownModule } from 'src/app/core/custom-modules/dropdowns/recipient-multiselect-dropdown/recipient-multiselect-dropdown.module';
import { GenericDropdownModule } from 'src/app/core/custom-modules/dropdowns/generic-dropdown/generic-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    GroupMaintenanceRoutingModule,
    WebUserDropdownModule,
    WebUserMultiselectDropdownModule,
    RecipientDropdownModule,
    RecipientMultiselectDropdownModule,
    GenericDropdownModule
  ],
  declarations: [GroupMaintenanceComponent, GroupMaintenanceDetailComponent, GrpMntDetailModalComponent, GrpMntWebUserModalComponent, GrpMntRecipientModalComponent, GroupMaintenanceFilterComponent],
  entryComponents: [
    GrpMntDetailModalComponent, 
    GrpMntWebUserModalComponent, 
    GrpMntRecipientModalComponent,
    GroupMaintenanceFilterComponent
  ]
})
export class GroupMaintenanceModule { }
